import React, { useMemo } from 'react';
import { AppBar } from '@mui/material';
import useAccounts from 'context/useAccounts';
import useToggle from 'hooks/useToggle';
import useWindowSize from 'hooks/useWindowSize';

import DesktopMenu from 'components/desktopMenu/DesktopMenu';
import MobileMenu from 'components/mobileMenu/MobileMenu';
import ContactModal from 'components/modals/ContactModal';

const Header = (props) => {
    const { children } = props;
    const { accounts } = useAccounts();
    const screenSize = useWindowSize();
    const [displayContactUsModal, toggleContactUsModal] = useToggle();
    const ownersName = accounts && accounts.length ? accounts[0].ownerName : '';

    const isWideScreen = useMemo(() => screenSize.width >= 900, [screenSize.width]);

    return (
        <React.Fragment>
            <AppBar className="header-container" position="sticky" style={{ zIndex: 105 }}>
                {isWideScreen ? (
                    <DesktopMenu ownersName={ownersName} toggleContactUsModal={toggleContactUsModal}>
                        {children}
                    </DesktopMenu>
                ) : (
                    <MobileMenu ownersName={ownersName} toggleContactUsModal={toggleContactUsModal}>
                        {children}
                    </MobileMenu>
                )}
            </AppBar>

            {displayContactUsModal && <ContactModal onOk={toggleContactUsModal} visible={displayContactUsModal} />}
        </React.Fragment>
    );
};

export default Header;
